import React from 'react';
import styled from '@emotion/styled';
import * as reactShare from 'react-share/es';
import PropTypes from 'prop-types';
import Custom from './Custom';

const SocialWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  > div {
    flex: 0 0 30px;
    height: 30px;
    width: 30px;
    padding: 5px;
    display: inline-flex;
    justify-content: center;
    align-items: flex-end;
    cursor: pointer;
  }
`;

const Social = (properties) => {
  const { data, className } = properties;
  const result = data.map((shareModal, index) => {
    const Button = reactShare[`${shareModal.name}ShareButton`];
    const Icon = reactShare[`${shareModal.name}Icon`];
    const id = `share-${index}`;
    if (Button && Icon) {
      return (
        <Button
          {...shareModal.modalProps}
          key={id}
          className={shareModal.className}
          additionalProps={shareModal.additionalProps}
        >
          <Icon
            {...shareModal.iconProps}
            size={shareModal.iconProps.size ?? 30}
            round
            className={`${shareModal.className}`}
          />
        </Button>
      );
    }
    return (
      <Custom
        key={id}
        modalProps={shareModal.modalProps}
        iconProps={shareModal.iconProps}
      />
    );
  });
  return (
    <SocialWrapper className={className}>
      {result}
    </SocialWrapper>
  );
};

Social.defaultProps = {
  data: [],
  className: undefined,
};

Social.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
};

export default Social;
